import { call, put, takeLatest } from "redux-saga/effects";

import { ApiService } from "pwapi";

import {
  LABSTAINS_LIST_FAILURE,
  LABSTAINS_LIST_REQUEST,
  LABSTAINS_LIST_SUCCESS,
  STAINS_LIST_FAILURE,
  STAINS_LIST_REQUEST,
  STAINS_LIST_SUCCESS,
} from "../actions/constants";

function* fetchStains(action: any): any {
  try {
    const results = yield call(ApiService.listStainLists, action.payload);
    yield put({ type: STAINS_LIST_SUCCESS, payload: results });
  } catch (e) {
    yield put({
      type: STAINS_LIST_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* fetchLabStains(action: any): any {
  try {
    const results = yield call(ApiService.listLabStainLists, action.payload);
    yield put({
      type: LABSTAINS_LIST_SUCCESS,
      payload: { response: results, labId: action.payload.parentLookupLabId },
    });
  } catch (e) {
    yield put({
      type: LABSTAINS_LIST_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* stainsSaga() {
  yield takeLatest(STAINS_LIST_REQUEST, fetchStains);
  yield takeLatest(LABSTAINS_LIST_REQUEST, fetchLabStains);
}
